import React, { FC } from 'react';

import { useTheme } from '../../util/theme';
import { tokens } from '../../util/theme/fluent9';

import CoreUIBaseButton from './BaseButton';
import { getButtonStyles } from './Button.styles.legacy';
import { ButtonProps } from './Button.types';

const Button: FC<ButtonProps> = (props) => {
  const { color = 'secondary', fullWidth = false, borderRadius = tokens.borderRadiusSmall, ...baseButtonProps } = props;
  const { status = 'enabled' } = props;

  const theme = useTheme();
  const styles = getButtonStyles({ theme, color, fullWidth, status, hasText: !!props.text, borderRadius });

  return <CoreUIBaseButton {...baseButtonProps} styles={styles} />;
};

export default Button;
